import React from 'react';
export function StickyAlertBar() {
  return <div className="bg-urgency text-white py-2 px-3 md:px-4 text-center text-[11px] sm:text-xs md:text-sm font-medium z-50 relative flex items-center justify-center gap-2 leading-tight" data-id="element-240">
      <span className="relative flex h-2 w-2 shrink-0" data-id="element-241">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-75" data-id="element-242"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-gold" data-id="element-243"></span>
      </span>
      <p data-id="element-244">
        <span className="text-gold font-bold" data-id="element-245">
          ⚡ Oferta por tiempo limitado
        </span>
        <span className="hidden sm:inline" data-id="element-246">
          {' '}
          · Hoy accedes al sistema completo con TODOS los bonos por solo $9,99
          USD
        </span>
        <span className="sm:hidden" data-id="element-247"> · Solo $9,99 USD hoy</span>
      </p>
    </div>;
}